import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

export const EmailInput = ({onChange, value}) => (
    <input className="email-input" type="email" name="share-email" autoComplete="off" onChange={onChange} value={value}
        placeholder={i18n.t('sharing_link.invite.input')}/>
);

EmailInput.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/EmailInput/index.js